import { createApp } from 'vue'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import VueSmoothScroll from 'vue3-smooth-scroll'
import App from './App.vue'

createApp(App)
  .use(VueReCaptcha, { siteKey: '6LfmIHweAAAAAMQRpzgjRFGlMySng1VOQb-Yjqp7' })
  .use(VueSmoothScroll)
  .mount('#app')

console.log('api url: ', process.env.VUE_APP_API_URL)
console.log('site url: ', process.env.VUE_APP_SITE_URL)